






























































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ModelsService } from "@/services/Models.service.ts";
import Number from "@/shared/filters/Number";
import { ModelItem } from "@/models/Model.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import { KyotenData } from "@/models/KyotenData";
import { CommonService } from '@/services/Common.service';

export interface ModelItemTb extends ModelItem {
  isEdit?: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable
  }
})
export default class ModelDetail extends Vue {
  @Prop({ default: "" })
  title: string;
  public modelService = new ModelsService();
  public commonService = new CommonService();
  public modelData: ModelItem;
  public modelEdit: ModelItem;
  public modelList: ModelItemTb[] = [];
  public modelItemList: ModelItemTb[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;
  public kyotenDataList: KyotenData[] = [];
  public form: any = {
    kyotenSelected: "",
    youtoSelected: "",
    jidoushaShubetsuSelected: ""
  };
  public dialogFormVisible: boolean = false;
  maxModel: number = 10;
  disableBtnAdd: boolean = true;
  timerReOrder: any = null;

  jidoushaShubetsuList: any = [];
  youtoList: any = [];

  get modelIndex() {
    let id: number = 0;
    if (this.modelList.length !== 0) {
      id = +this.modelList[this.modelList.length - 1].id;
    }
    return id + 1;
  }

  constructor() {
    super();

    this.modelData = {
      id: "",
      kyotenCd: "",
      modelNm: ""
    };

    this.modelEdit = {
      id: "",
      kyotenCd: "",
      modelNm: "",
      youtoKbn: "",
      jidoushaShubetsuKbn: ""
    };
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.modelData.modelNm) {
      this.loading = true;
      const data = {
        ...this.modelData,
        kyotenCd: this.form.kyotenSelected,
        id: this.modelIndex.toString()
      };
      this.addModelItem({ ...data });
    }
  }

  public async getKyotenDataList() {
    const response = await this.modelService.getKyotens();
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
  }

  public async getKbnSkns(nameKbn: string, sknTitle: string, kbnCd?: string) {
    const response = await this.commonService.getKbnSkns(sknTitle, kbnCd);
    if (response) {
      let data = response.filter((e: any) => e.isDisabled == 0);
      data = data.sort((a: any, b: any) => (a.kbnKey > b.kbnKey ? 1 : -1));
      this.$set(this, nameKbn, [...data]);
    } else {
      this.$set(this, nameKbn, []);
    }
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenSelected
    );
    this.getModelList(this.form.kyotenSelected);
    this.delay(1000);
  }

  public async getModelList(kyoten: string, id?: number) {
    const response = await this.modelService.getModels(kyoten, id);
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "modelList", [...data]);
    } else {
      this.$set(this, "modelList", []);
    }
    this.checkDisabledAdd();
  }

  public async addModelItem(data: ModelItem) {
    const response = await this.modelService.editModel(data);
    if (response) {
      this.getModelList(this.form.kyotenSelected);
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public async delModelItem(id: number) {
    this.loading = true;
    const response = await this.modelService.deleteModel(id);
    if (response === 200) {
      this.getModelList(this.form.kyotenSelected);
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.modelEdit = { ...rowData };
  }

  public editModelItem() {
    this.loading = true;
    if (this.modelEdit.id && this.modelEdit.modelNm) {
      const data = {
        id: this.modelEdit.id,
        kyotenCd: this.form.kyotenSelected,
        modelNm: this.modelEdit.modelNm
      };
      this.addModelItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private mounted() {
    this.getKyotenDataList();
    this.getKbnSkns("jidoushaShubetsuList", "skn_jidousha_shubetsu", "7101");
    this.getKbnSkns("youtoList", "skn_youto");
    this.form.kyotenSelected = localStorage.getItem("kyotenCd");
    this.getModelList(this.form.kyotenSelected);
  }

  checkDisabledAdd() {
    let disabled = false;
    if (this.modelList.length >= this.maxModel) {
      disabled = true;
    } else if (this.modelData.modelNm === "") {
      disabled = true;
    }

    this.$set(this, "disableBtnAdd", disabled);
  }

  onEnd(event: any) {
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      const data = this.modelList.map((e: any) => {
        let item = { ...e };
        delete item.isEdit;
        return item;
      });
      this.saveModelList(data);
    }, 1000);
  }

  public async saveModelList(data: any[]) {
    const response = await this.modelService.saveModels(data);
    if (response) {
      console.log(response);
    }
  }
}
